<div class="forward-curve-container content">
  <div class="menu-bar">
    Forward Curve
    <div>
      <button
        class="menu-bar--right-button-close"
        (click)="closeWidget()"
      ></button>
    </div>
  </div>

  <div class="forward-curve-container__selector">
    <app-selector
      [passedItems]="currencyPairs"
      [isSearch]="true"
      [defaultValue]="currencyPairs[0]"
      (valueEmitter)="onCurrencyPairChanged($event.value)"
    ></app-selector>
  </div>

  <table ui-table *ngIf="dataLoaded | async">
    <thead>
      <tr>
        <th class="tenor-header">Tenor</th>
        <th class="value-header">FwdPts Bid</th>
        <th class="value-header">FwdPts Offer</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let period of periods">
        <td>{{ periodToLabel[period] }}</td>
        <td
          [ngClass]="[
            'number-cell',
            'ui-value-color',
            data[period]?.bid | valueColorsHeatMapSigned: minValue : maxValue
          ]"
        >
          {{ data[period]?.bid | number: '1.2-2' }}
        </td>
        <td
          [ngClass]="[
            'number-cell',
            'ui-value-color',
            data[period]?.ask | valueColorsHeatMapSigned: minValue : maxValue
          ]"
        >
          {{ data[period]?.ask | number: '1.2-2' }}
        </td>
      </tr>
    </tbody>
  </table>
  <div *ngIf="marketDataErrorMsg" class="forward-curve-container__error">
    {{ marketDataErrorMsg }}
  </div>
</div>
